import { Transporter } from './transporter.model';
import { Offer } from './offer.model';
import { Vehicle } from './vehicle.model';
import { CalculationMethodEnum } from './enums/calculation-method.enum';

export class OfferVehicle {
  public id!: string;
  public transporter!: Transporter;
  public offer!: Offer;
  public vehicle!: Vehicle;
  public isActive!: boolean;
  public calculationMethod: CalculationMethodEnum = CalculationMethodEnum.ADD_FIXED;
  public value: number | null;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.transporter = new Transporter(data.transporter);
    this.offer = new Offer({ ...data.offer, transporter: data.transporter });
    this.vehicle = new Vehicle(data.vehicle);
    this.value = data.value ?? null;
  }

  public serialize(): any {
    return {
      id: this.id,
      transporter: { id: this.transporter.id },
      offer: { id: this.offer.id },
      vehicle: { id: this.vehicle.id },
      isActive: this.isActive,
      calculationMethod: this.calculationMethod,
      value: this.value,
    };
  }
}

export class OfferVehicleView extends OfferVehicle {
  public isSelected: boolean;

  constructor(data: any = {}) {
    super(data);
    this.isSelected = data.isSelected || false;
  }

  public override serialize(): any {
    return {
      ...super.serialize(),
      isSelected: this.isSelected,
    };
  }
}
